import { normalizeStructTag, SUI_TYPE_ARG } from '@mysten/sui/utils';

import type { CryptoAsset } from './use-crypto-assets';

export const isNativeSuiAsset = ({ coinType }: Pick<CryptoAsset, 'coinType'>) =>
  normalizeStructTag(coinType) === SUI_TYPE_ARG;
